import { quantile, extent } from "d3-array";
import { hasKey, checkTypeOfKey, log, toPercentage, } from "../../exports/helpers.js";
export default function excludeOutliers(data, key, nbTestedValues = 10000, verbose = false) {
    hasKey(data, key);
    checkTypeOfKey(data, key, "number", 1, nbTestedValues, verbose);
    const values = data.map((d) => d[key]);
    const q1 = quantile(values, 0.25);
    const q3 = quantile(values, 0.75);
    const interQuartileRange = q3 - q1;
    const upper = q3 + interQuartileRange * 1.5;
    const lower = q1 - interQuartileRange * 1.5;
    const [min, max] = extent(values);
    verbose &&
        log(`Min: ${min}, Lower threshold: ${lower}, Q1: ${q1}, Q3: ${q3}, Upper threshold: ${upper}, Max: ${max}`, "blue");
    const filteredData = data.filter((d) => d[key] >= lower && d[key] <= upper);
    const outliers = data.length - filteredData.length;
    verbose &&
        log(`/!\\ ${outliers} outliers found and excluded, representing ${toPercentage(outliers, data.length)} of the incoming data.`, "bgRed");
    return filteredData;
}
//# sourceMappingURL=excludeOutliers.js.map